// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoggingService } from '../services/logging.service';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../services/auth.service';
import { AppInitService } from '../services/app-init.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  title = 'Angular';
  defaultRouterLinkOption = { exact: true }
  navBarContents: { title: string, route: string, routerLinkActiveOptions?: any }[] = [
    {
      title: "Home",
      route: "",
      routerLinkActiveOptions: this.defaultRouterLinkOption
    },
    {
      title: "Test",
      route: "test",
      routerLinkActiveOptions: this.defaultRouterLinkOption
    },
    {
      title: "Device Info",
      route: "deviceInfo",
      routerLinkActiveOptions: this.defaultRouterLinkOption
    }
  ];

  constructor(
    private loggingService: LoggingService,
    private router: Router,
    private titleService: Title,
    private authService: AuthService,
    private appInitService: AppInitService
  ) {
  }

  ngOnInit(): void {
    // Handle root URL redirect with redirectTo parameter
    this.handleRootUrlRedirect();

    this.loggingService.logPageView('Home Page', window.location.href);
    // Listen to navigation events and log the page view on route change
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((event: any) => {
      const navigationEvent = event as NavigationEnd;

      const pageTitle = this.titleService.getTitle();
      this.loggingService.logPageView(pageTitle, navigationEvent.urlAfterRedirects);
    });

    // this.authService.
  }

  /**
   * Handle redirect from root URL with redirectTo parameter
   * E.g., https://localhost:52770/?redirectTo=%2FanandWedsRina -> https://localhost:52770/anandWedsRina
   */
  private handleRootUrlRedirect(): void {
    // Get the current pathname and search
    const pathname = window.location.pathname;
    const search = window.location.search;

    // Check if we're on root URL (/ or empty path)
    const isRootUrl = pathname === '/' || pathname === '';

    if (isRootUrl && search.includes('redirectTo=')) {
      // Get redirectTo parameter from query string
      const params = new URLSearchParams(search);
      const redirectTo = params.get('redirectTo');

      if (redirectTo) {
        // Decode the URL-encoded path and redirect
        const decodedPath = decodeURIComponent(redirectTo);
        // Reject absolute URLs and protocol-relative URLs to prevent open redirect
        if (!decodedPath.startsWith('/') || decodedPath.startsWith('//')) {
          return;
        }
        window.location.href = decodedPath;
      }
    }
  }

  get showSidebar(): boolean {
    return this.router.url !== '/';
  }
}
